module.exports = __webpack_public_path__ + "img/icon-76.2289edea.png";